var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Proto",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-menu",
    transform: "translate(-1210.000000, -50.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(920.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(290.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4099045,20.935455 C24.1126523,21.6363029 24.1126523,22.7734134 23.4099045,23.474336 C22.7071568,24.1752587 21.5669638,24.1751839 20.864141,23.474336 L12.0012236,14.5695511 L3.07529959,23.4713438 C2.37255185,24.1721917 1.23235882,24.1721917 0.529536065,23.4713438 C-0.173286688,22.770496 -0.17321168,21.6333855 0.529536065,20.9324628 L9.45846035,12.0336622 L0.527060809,3.06454501 C-0.175686936,2.36369714 -0.175686936,1.22658663 0.527060809,0.525663953 C1.22980855,-0.17525872 2.37000158,-0.175183915 3.07282434,0.525663953 L12.0012236,9.49777338 L20.9271475,0.595980635 C21.6298953,-0.104867232 22.7700883,-0.104867232 23.4729111,0.595980635 C24.1757338,1.2968285 24.1756588,2.43393902 23.4729111,3.13486169 L14.5439868,12.0336622 L23.4099045,20.935455 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ce5a4ed0d9351f4fa9c006582b2ea580.svg";
export { ForwardRef as ReactComponent };